var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivateviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.029,
    height: 20.039,
    viewBox: "0 0 15.029 20.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.612,7.515H77.359V5.845a5.845,5.845,0,0,0-11.689,0v1.67H64.417A.417.417,0,0,0,64,7.932V18.369a1.672,1.672,0,0,0,1.67,1.67H77.359a1.672,1.672,0,0,0,1.67-1.67V7.932A.417.417,0,0,0,78.612,7.515Zm-5.847,8.721a.418.418,0,0,1-.415.464H70.68a.418.418,0,0,1-.415-.464l.263-2.368a1.652,1.652,0,0,1-.683-1.343,1.67,1.67,0,0,1,3.34,0,1.652,1.652,0,0,1-.683,1.343Zm2.09-8.721h-6.68V5.845a3.34,3.34,0,0,1,6.68,0Z",
    transform: "translate(-64)",
    fill: "#697384"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateviews);
export default __webpack_public_path__ + "static/media/privateviews.517b138ae50ada68504d14c3f0d0b488.svg";
export { ForwardRef as ReactComponent };